import {
  WhatsAppLogoFlatSVG,
  TelegramLogoFlatSVG,
  FacebookLogoSVG,
} from "@/components/svg";
import { useRouter } from "next/router";

export default function SocialShareButtons({ post }) {
  const router = useRouter();
  const url = `${process.env.NEXT_PUBLIC_HOST}${router.asPath}`;
  return (
    <>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:opacity-70"
        aria-label="Share on Facebook"
        title="Share on Facebook"
      >
        <FacebookLogoSVG className="w-6 2xl:w-7 h-auto" />
      </a>
      <a
        href={`whatsapp://send?text=${post.title} ${url}`}
        data-action="share/whatsapp/share"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:opacity-70"
        aria-label="Share on WhatsApp"
        title="Share on WhatsApp"
      >
        <WhatsAppLogoFlatSVG className="w-6 2xl:w-7 h-auto" />
      </a>
      <a
        href={`https://t.me/share/url?url=${url}&text=${post.title}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:opacity-70"
        aria-label="Share on Telegram"
        title="Share on Telegram"
      >
        <TelegramLogoFlatSVG className="w-6 2xl:w-7 h-auto" />
      </a>
    </>
  );
}
